"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamErc20Transfer = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var common_evm_utils_1 = require("@moralisweb3/common-evm-utils");
var StreamTriggerOutput_1 = require("../StreamTriggerOutput");
/**
 * The StreamErc20Transfer class is a representation of a erc20 transfer that is returned by the Moralis Stream API
 *
 * @category DataType
 */
var StreamErc20Transfer = /** @class */ (function () {
    function StreamErc20Transfer(data, core) {
        this._data = StreamErc20Transfer.parse(data, core);
    }
    /**
     * Create a new instance of StreamErc20Transfer
     *
     * @param data - the StreamErc20Transferish type
     * @param core - the Core instance
     * @example
     * ```ts
     * const erc20Transfer = StreamErc20Transfer.create(data);
     * ```
     * @returns an instance of StreamErc20Transfer
     */
    StreamErc20Transfer.create = function (data, core) {
        if (data instanceof StreamErc20Transfer) {
            return data;
        }
        var finalCore = core !== null && core !== void 0 ? core : common_core_1.CoreProvider.getDefault();
        return new StreamErc20Transfer(data, finalCore);
    };
    /**
     * Compares two StreamErc20Transfer data. It checks a deep equality check of both values.
     * @param valueA - the first StreamErc20Transferish data to compare
     * @param valueB - the second StreamErc20Transferish data to compare
     * @returns true if the values are equal, false otherwise
     * @example
     * ```ts
     *  StreamErc20Transfer.equals(valueA, valueB);
     * ```
     */
    StreamErc20Transfer.equals = function (valueA, valueB) {
        var _a, _b;
        var erc20TransferA = StreamErc20Transfer.create(valueA);
        var erc20TransferB = StreamErc20Transfer.create(valueB);
        if (!erc20TransferA.chain.equals(erc20TransferB.chain)) {
            return false;
        }
        if (erc20TransferA.transactionHash !== erc20TransferB.transactionHash) {
            return false;
        }
        if (erc20TransferA.logIndex !== erc20TransferB.logIndex) {
            return false;
        }
        if (((_a = erc20TransferA.triggers) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = erc20TransferB.triggers) === null || _b === void 0 ? void 0 : _b.length) ||
            !StreamTriggerOutput_1.StreamTriggerOutput.arrayEquals(erc20TransferA.triggers || [], erc20TransferB.triggers || [])) {
            return false;
        }
        return true;
    };
    /**
     * Compares an StreamErc20Transferish data to this StreamErc20Transfer instance.
     * @param value - the value to compare
     * @returns true if the value is equal to the current instance, false otherwise
     * @example
     * ```ts
     * erc20Transfer.equals(value);
     * ```
     */
    StreamErc20Transfer.prototype.equals = function (value) {
        return StreamErc20Transfer.equals(this, value);
    };
    /**
     * Converts the StreamErc20Transfer instance to a JSON object.
     * @returns JSON object of the StreamErc20Transfer instance
     * @example `erc20Transfer.toJSON()`
     */
    StreamErc20Transfer.prototype.toJSON = function () {
        var _a = this._data, chain = _a.chain, from = _a.from, to = _a.to, contract = _a.contract, value = _a.value, triggers = _a.triggers, data = __rest(_a, ["chain", "from", "to", "contract", "value", "triggers"]);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return __assign(__assign({}, data), { chain: chain.format(), from: from.format(), to: to.format(), contract: contract.format(), value: value.toString(), triggers: triggers === null || triggers === void 0 ? void 0 : triggers.map(function (trigger) { return trigger.format(); }) });
    };
    /**
     * Converts the StreamErc20Transfer instance to a JSON object.
     * @returns JSON object of the StreamErc20Transfer instance
     * @example `erc20Transfer.format()`
     */
    StreamErc20Transfer.prototype.format = function () {
        return this.toJSON();
    };
    Object.defineProperty(StreamErc20Transfer.prototype, "chain", {
        get: function () {
            return this._data.chain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "transactionHash", {
        get: function () {
            return this._data.transactionHash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "logIndex", {
        get: function () {
            return this._data.logIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "from", {
        get: function () {
            return this._data.from;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "to", {
        get: function () {
            return this._data.to;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "value", {
        get: function () {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "contract", {
        get: function () {
            return this._data.contract;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "tokenName", {
        get: function () {
            return this._data.tokenName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "tokenSymbol", {
        get: function () {
            return this._data.tokenSymbol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "tokenDecimals", {
        get: function () {
            return this._data.tokenDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "valueWithDecimals", {
        get: function () {
            return this._data.valueWithDecimals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StreamErc20Transfer.prototype, "triggers", {
        get: function () {
            return this._data.triggers;
        },
        enumerable: false,
        configurable: true
    });
    StreamErc20Transfer.parse = function (data, core) {
        var chain = common_evm_utils_1.EvmChain.create(data.chain, core);
        return __assign(__assign({}, data), { chain: chain, from: common_evm_utils_1.EvmAddress.create(data.from, core), to: common_evm_utils_1.EvmAddress.create(data.to, core), logIndex: +data.logIndex, contract: common_evm_utils_1.EvmAddress.create(data.contract, core), value: common_core_1.BigNumber.create(data.value), valueWithDecimals: (0, common_core_1.maybe)(data.valueWithDecimals), tokenDecimals: data.tokenDecimals === '' ? undefined : +data.tokenDecimals, triggers: (0, common_core_1.maybe)(data.triggers, function (triggers) {
                return triggers.map(function (trigger) { return StreamTriggerOutput_1.StreamTriggerOutput.create(trigger, core); });
            }) });
    };
    return StreamErc20Transfer;
}());
exports.StreamErc20Transfer = StreamErc20Transfer;
//# sourceMappingURL=StreamErc20Transfer.js.map